<div style="height:calc(100vh - 176px); overflow-y: auto;">
  <div class="container-fluid">
    <!--    GENERAL SETTINGS-->
    <form id="buForm" #buForm [formGroup]="userForm" (ngSubmit)="save()">
      <!--      row start-->
      <div class="row justify-content-center pt-4">
        <div class="col-12 col-md-11">
          <span class="rm-title rm-title-3">Mandate Information</span><br/>
          <span *ngIf="util.isInvestor()" class="rm-title rm-title-6">
            Your investment mandates help our algorithms match you with deals that are a natural fit for your investment strategy.  If you need to adjust or update your mandate metrics, please contact Rondeivu.
          </span>
          <span *ngIf="util.isAdmin()" class="rm-title rm-title-6">
            Rondeivu Admin can update mandate metrics, or change mandate status from this page.
          </span>
        </div>
      </div>
      <!--      row start-->
      <div class="row justify-content-center pt-2 pb-5">
        <div class="col-12 col-md-11">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="row pt-4">
                <span class="pb-2" style="font-size: large;font-weight: bold;">Mandate Status</span>
                <br />
                <span *ngIf="util.isInvestor()" style="font-size: large;" [appStatus]="userForm.get('workflowStatus')?.value || ''">{{userForm.get('workflowStatus')?.value}}</span>

                <mat-form-field *ngIf="util.isAdmin()" class="form-field" appearance="outline">
                  <mat-label>Mandate Status</mat-label>
                  <mat-select formControlName="workflowStatus">
                    <mat-option *ngFor="let c of lookupService.lookups.investorMandateWorkflowStatus" [value]="c.key">
                      {{c.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div>
                
              </div>
            </div>
          </div>
          <!--      row start-->
          <div class="row pt-4">
            <span style="font-size: large;font-weight: bold;">Mandate Details</span>
          </div>
          <br/>
          <!--          row start-->
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="radio-group" formArrayName="investorMandateDeals">
                <b><mat-label>Deal Type<sup>*</sup></mat-label></b>
                <div *ngFor="let dealType of dealTypes.controls; index as i;">
                  <mat-checkbox color="primary" [formControlName]="i">{{ lookupService.lookups.dealTypes[i].value }}</mat-checkbox>
                </div>
                <mat-error *ngIf="userForm.get('investorMandateDeals')?.hasError('minChecked')">At least one checkbox must be checked</mat-error>
              </div>
            </div>
            <div class="col-12 d-md-none">
              &nbsp;
            </div>
            <div class="col-12 col-md-6">
              <b><mat-label>Asset Class<sup>*</sup></mat-label></b>
              <div class="radio-group" formArrayName="investorMandateAssets" style="display: flex; flex-direction: column; gap: 1px;">
                <ng-container *ngFor="let asset of assetClasses.controls; index as i;">
                  <mat-checkbox color="primary" [formControlName]="i">{{ lookupService.lookups.assetTypes[i].value }}</mat-checkbox>
                </ng-container>
                                <mat-error *ngIf="userForm.get('investorMandateAssets')?.hasError('minChecked')">At least one checkbox must be checked</mat-error>
              </div>
            </div>
          </div>
          <br/>
<!--          Investment Opportunities-->
          <div class="row pt-4">
            <span style="font-size: large;font-weight: bold;">Investment Opportunities</span>
          </div>
          <br/>
          <!-- row start-->
          <div class="row">
            <div class="col-12">
              <!--notes-->
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Notes</mat-label>
                <textarea matInput id="notes" placeholder="Type here..."
                          formControlName="notes"></textarea>
              </mat-form-field>
            </div>
          </div>
          <!--          row start-->
          <div class="row">
            <div class="col-12">
              <mat-label style="font-size: medium;">Keywords</mat-label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-chip-list #chipList aria-label="Select Keywords">
                  <mat-chip *ngFor="let st of selectedThemes" (removed)="removeWork(st)">
                    {{st}}
                    <button matChipRemove><mat-icon>cancel</mat-icon></button>
                  </mat-chip>
                  <input
                    [placeholder]="selectedThemes.length==0? 'Music Royalties, Bourbon, Leasing...': ''"
                    #themeInput
                    [formControl]="chipInputCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addWord($event)"/>
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTheme($event)">
                  <mat-option *ngFor="let ft of lookupService.lookups.areasOfFocus" [value]="ft.key">
                    {{ft.value}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <!--      row start-->
          <div class="row pt-4">
            <span style="font-size: large;font-weight: bold;">Assets Under Management</span>
          </div>
          <!--      row start-->
          <div class="row justify-content-center pt-4">
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Firm AUM</mat-label>
                <input matInput id="firm-aum" type="number" [required]="true" formControlName="firmAum"/>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Program AUM</mat-label>
                <input matInput id="program-aum" type="number" [required]="true" formControlName="programAum"/>
              </mat-form-field>
            </div>
          </div>
          <!--      row start-->
          <div class="row opt-4">
            <span style="font-size: large;font-weight: bold;">Multiple on Invested Capital</span>
          </div>
          <!--      row start-->
          <div class="row justify-content-center" style="padding-top: 25px;">
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Target Net MOIC</mat-label>
                <input matInput id="target-moic" type="number" [required]="true" formControlName="targetNetMoic"/>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Target Net IRR</mat-label>                
                <input matInput id="target-irr" type="number" [required]="true" formControlName="targetNetIrr"/>
              </mat-form-field>
            </div>
          </div>
          <!--      row start-->
          <div class="row pt-4">
            <span style="font-size: large;font-weight: bold;">Duration</span>
          </div>
          <!--      row start-->
          <div class="row justify-content-center" style="padding-top: 25px;">
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Minimum Duration</mat-label>                
                <input matInput type="number" id="min-duration" [required]="true"
                       formControlName="minimumDuration"/>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Maximum Duration</mat-label>
                <input matInput type="number" id="max-duration" required="true"
                       formControlName="maximumDuration"/>
              </mat-form-field>
            </div>
          </div>
          <!--      row start-->
          <div class="row pt-4">
            <span style="font-size: large;font-weight: bold;">Ticket Size</span>
          </div>
          <!--      row start-->
          <div class="row justify-content-center" style="padding-top: 25px;">
            <div class="col-12 col-md-4">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Minimum Ticket Size</mat-label>
                <input matInput type="number" id="min-ticket" required="true"
                       formControlName="minTicketSize">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Maximum Ticket Size</mat-label>
                <input matInput type="number" id="max-ticket" required="true"
                       formControlName="maxTicketSize">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Average Ticket Size</mat-label>
                <input matInput type="number" id="avg-ticket" required="true"
                       formControlName="avgTicketSize">
              </mat-form-field>
            </div>
          </div>
          <!--      row start-->
          <div class="row pt-4">
            <span style="font-size: large;font-weight: bold;">Other</span>
          </div>
          <!--      row start-->
          <div class="row" style="padding-top: 25px;">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Minimum Timeline to Close</mat-label>
                <mat-select formControlName="investorMandateTimeLines">
                  <mat-option *ngFor="let tl of lookupService.lookups.timeLineTypes" [value]="tl.key">
                    {{tl.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!--            investorMandateAnchorInterests-->
            <div class="col-12 col-md-6">
              <div class="radio-group" formArrayName="investorMandateAnchorInterests">
                <mat-label>Are you interested in being any of the following?</mat-label>
                <div *ngFor="let type of anchorInterestTypes.controls; index as i;">
                  <mat-checkbox color="primary" [formControlName]="i">{{ lookupService.lookups.anchorInterestTypes[i].value }}</mat-checkbox>
                </div>
              </div>
            </div>
          </div>
          <!--      row start-->
          <div class="row justify-content-center pt-5">
            <div class="col-12 text-end">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                [hasPermission]="util.Permission.CAN_EDIT_MANDATES"
                [disabledOption1]="{ condition: userForm.invalid, message: 'Form not valid' }"
              >
                Save Mandate Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="notes-tongue" *ngIf="util.isAdmin()" (click)="notesService.launchNotes()">
  <mat-icon role="img" title="Mandate Notes">description</mat-icon>
</div>